import { ComponentClass, FunctionComponent } from 'react';
import Article from '../views/article/Article';
import Booking from '../views/booking/Booking';
import HomeSliderRoutes from '../views/CMS/HomeSlider/Routes';
import Customer from '../views/listCustomer/Customer';
import CustomerDetail from '../views/listCustomer/CustomerDetail';
import ListDirectDiscount from '../views/listDirectDiscount';
import ListModule from '../views/listModule';
import MoneyTransferRequest from '../views/listMoneyTransferRequest';
import ListNotification from '../views/listNotification/ListNotification';
import ListPromotion from '../views/listPromotion';
import ListRegion from '../views/listRegion';
import ListUser from '../views/listUser';
import ListUserGroup from '../views/listUserGroup';
import Partner from '../views/partner/Partner';
import VehiclePartner from '../views/vehiclePartner/VehiclePartner';
import Warehouse from '../views/warehouse/Warehouse';
import Testimonial from '../views/Testimonial/Testimonial';
import Widget from '../views/widget';
import Home from '../views/home/Home';
import MarketingLead from '../views/marketingLead/MarketingLead';
import Deposit from '../views/booking/Deposit';

export interface RouteConfig {
  name: string;
  path?: string;
  component?: FunctionComponent<any> | ComponentClass<any>;
  children?: RouteConfig[];
}

const routes: RouteConfig[] = [
  {
    path: '/vehicle-depot',
    name: 'Xe',
    component: Warehouse,
  },
  {
    path: '/vehicle-partner',
    name: 'Xe đối tác',
    component: VehiclePartner,
  },
  {
    path: '/partner',
    name: 'Đối tác',
    component: Partner,
  },
  {
    path: '/booking',
    name: 'Đơn đặt',
    component: Booking,
  },
  {
    path: '/deposit',
    name: 'Đặt cọc',
    component: Deposit,
  },

  {
    path: '/notify',
    name: `Thông báo`,
    component: ListNotification,
  },
  {
    path: '/customer',
    name: 'Khách hàng',
    component: Customer,
  },
  {
    path: '/customer-detail',
    name: 'Thông tin chi tiết khách hàng',
    component: CustomerDetail,
  },
  {
    path: '/region',
    name: 'Vùng miền',
    component: ListRegion,
  },
  {
    path: '/promotion',
    name: 'Khuyến mãi',
    component: ListPromotion,
  },
  {
    path: '/direct-discount',
    name: 'Giảm giá',
    component: ListDirectDiscount,
  },
  {
    name: 'Phân quyền',
    children: [
      {
        path: '/user',
        name: 'Người dùng',
        component: ListUser,
      },
      {
        path: '/group',
        name: 'Nhóm người dùng',
        component: ListUserGroup,
      },
      {
        path: '/module',
        name: 'Quản lý module',
        component: ListModule,
      },
    ],
  },

  {
    path: '/transfer-requests',
    name: 'Yêu cầu chuyển khoản',
    component: MoneyTransferRequest,
  },
  {
    name: 'CMS',
    children: [
      { name: 'Home slider', path: '/slide', component: HomeSliderRoutes },
      {
        path: '/testimonial',
        name: 'Testimonial',
        component: Testimonial,
      },
      {
        path: '/article',
        name: 'Bài viết',
        component: Article,
      },
    ],
  },
  {
    path: '/widget',
    name: 'Widget',
    component: Widget,
  },
  {
    path: '/marketing-lead',
    name: 'Marketing lead',
    component: MarketingLead,
  },
  {
    // this needs to be the last item
    path: '/',
    name: 'Home',
    component: Home,
  },
];

export default routes;
